import React, { useState, useEffect } from "react";
import MenuCategoriesService from "../../services/MenuCategoriesService";

const AddCategories = () => {
  const initialCategoriesState = {
    id: null,
    name: "",
    description: "",
    image: null,
    type: "",
    published: false,
  };

  const type = [
    { id: "1", name: "Food" },
    { id: "2", name: "Drinks" },
  ];

  const [categories, setCategories] = useState(initialCategoriesState);
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState(
    "You submitted successfully!"
  );
  // const [alert, setAlert] = useState("alert alert-danger");
  // const [image, setImage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCategories({ ...categories, [name]: value });
  };

  const handleSelectInputChange = (e) => {
    const { name } = e.target;
    const value = e.target.value;
    console.log("Selected Value : " + e.target.value);
    // setImage(inputimage)
    setCategories({
      ...categories,
      [name]: value === "---" ? "" : type[value - 1].name,
      // [name]: value === 1 ? "food" : "drinks",
    });
  };

  console.log(JSON.stringify(categories));

  const handleImageInputChange = (e) => {
    const { name } = e.target;
    const inputimage = e.target.files[0];
    // setImage(inputimage);
    setCategories({ ...categories, [name]: inputimage });
  };

  const saveCategories = () => {
    var data = {
      name: categories.name,
      description: categories.description,
      type: categories.type,
      image: categories.image,
    };

    MenuCategoriesService.create(data)
      .then((response) => {
        setCategories({
          id: response.data.id,
          name: response.data.name,
          description: response.data.description,
          image: response.data.image,
          type: response.data.type,
          published: response.data.published,
        });
        setSubmitted(true);
        // setAlert("alert alert-success");
        console.log(response.data.type);
      })
      .catch((e) => {
        setSubmitted(true);
        setServermessage("Error: " + e.response.data.message);
        console.log(e);
      });
  };

  const newCategory = () => {
    setCategories(initialCategoriesState);
    setSubmitted(false);
  };

  useEffect(() => {}, []);

  return (
    <div className="container pb-10">
      <>
        <h1 className="text-1xl lg:text-1xl font-semibold py-10">
          {" "}
          Add Menu Categories
        </h1>
        <div>
          {submitted ? (
            <div
              className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
              role="alert"
            >
              <p style={{ marginBottom: "0" }}>{servermessage}</p>
            </div>
          ) : (
            <>
              <p style={{ marginBottom: "0" }}></p>
            </>
          )}
          <br></br>
        </div>

        <form className="w-full">
          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                htmlFor="inline-full-name"
              >
                Name
              </label>
            </div>
            <div className="md:w-2/3">
              <input
                className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                type="text"
                id="name"
                required
                value={categories.name}
                onChange={handleInputChange}
                name="name"
              />
            </div>
          </div>

          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                htmlFor="inline-password"
              >
                Description
              </label>
            </div>
            <div className="md:w-2/3">
              <textarea
                rows="5"
                className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="description"
                name="description"
                type="text"
                value={categories.description}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                htmlFor="inline-password"
              >
                Menu Type
              </label>
            </div>
            <div className="md:w-2/3">
              <select
                id="type"
                name="type"
                type="text"
                className="bg-gray-200  border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                onChange={handleSelectInputChange}
              >
                <option>---</option>
                {type?.length > 0 &&
                  type.map((item, index) => (
                    <option
                      value={item.id}
                      key={index}
                    >
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3">
              <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
                Image
              </label>
            </div>
            <div className="md:w-2/3">
              <input
                className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                type="file"
                id="image"
                onChange={handleImageInputChange}
                name="image"
              />
            </div>
          </div>
        </form>

        <div className="md:flex md:items-center">
          <div className="md:w-1/3"></div>
          <div className="md:w-2/3 grid grid-cols-2 gap-40">
            {submitted ? (
              <div>
                <button
                  className="shadow bg-green-800 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="submit"
                  onClick={newCategory}
                >
                  Add New
                </button>
              </div>
            ) : (
              <>
                <button
                  className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="submit"
                  onClick={saveCategories}
                >
                  Submit
                </button>
              </>
            )}
          </div>
        </div>
      </>
    </div>
  );
};
export default AddCategories;
